var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "url(#paint0_linear_10828_3712)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8979 33.1604C40.6473 33.9545 40.128 34.6515 39.3943 35.0469C36.2931 36.7181 32.7745 37.6681 29.0398 37.6681C25.3051 37.6681 21.7865 36.7181 18.6854 35.0469C17.9516 34.6515 17.4324 33.9545 17.1818 33.1604C16.7722 31.8628 16.5467 30.4766 16.5467 29.0333C16.5467 27.5901 16.7722 26.2039 17.1818 24.9063C17.4324 24.1114 17.9516 23.4144 18.6846 23.0198C21.7865 21.3478 25.3051 20.3986 29.0398 20.3986C32.7745 20.3986 36.2931 21.3478 39.3943 23.0198C40.128 23.4144 40.6473 24.1114 40.8979 24.9063C41.3074 26.2039 41.533 27.5901 41.533 29.0333C41.533 30.4766 41.3074 31.8628 40.8979 33.1604ZM45.913 28.2823C44.5261 26.6605 42.9238 25.2446 41.1563 24.073C40.6755 23.7543 40.2996 23.3158 40.0372 22.802C37.929 18.6711 33.7996 15.8589 29.0398 15.8589C24.28 15.8589 20.1506 18.6711 18.0424 22.802C17.7801 23.3158 17.4042 23.7543 16.9234 24.073C15.1558 25.2446 13.5536 26.6605 12.1667 28.2823C11.8025 28.7076 11.8025 29.3591 12.1667 29.7844C13.5536 31.4062 15.1558 32.8221 16.9226 33.9929C17.4042 34.3116 17.7801 34.7509 18.0424 35.2647C20.1506 39.3948 24.28 42.207 29.0398 42.207C33.7996 42.207 37.929 39.3948 40.0372 35.2647C40.2988 34.7509 40.6755 34.3116 41.1563 33.9929C42.9238 32.8221 44.5261 31.4062 45.913 29.7844C46.2771 29.3591 46.2771 28.7076 45.913 28.2823Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1476 32.4922C34.3379 32.4922 33.6816 31.8359 33.6816 31.0262V27.0409C33.6816 26.2311 34.3379 25.5749 35.1476 25.5749C35.9574 25.5749 36.6137 26.2311 36.6137 27.0409V31.0262C36.6137 31.8359 35.9574 32.4922 35.1476 32.4922Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0397 32.4922C28.23 32.4922 27.5737 31.8359 27.5737 31.0262V27.0409C27.5737 26.2311 28.23 25.5749 29.0397 25.5749C29.8495 25.5749 30.5057 26.2311 30.5057 27.0409V31.0262C30.5057 31.8359 29.8495 32.4922 29.0397 32.4922Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9313 32.4922C23.7411 32.4922 24.3973 31.8359 24.3973 31.0262V27.0409C24.3973 26.2311 23.7411 25.5749 22.9313 25.5749C22.1216 25.5749 21.4653 26.2311 21.4653 27.0409V31.0262C21.4653 31.8359 22.1216 32.4922 22.9313 32.4922Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10828_3712",
    x1: 4.5519,
    y1: 51.3924,
    x2: 55.1367,
    y2: 11.3063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#3133CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DA1F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChatIcon);
export default __webpack_public_path__ + "static/media/new-chat-icon.9956ac6b694b33eb9254bf298d3ed4cf.svg";
export { ForwardRef as ReactComponent };